
export class UnescapeValueConverter {
    parser = new DOMParser();
    toView(text: string) {
        const result = this.parser.parseFromString(text, "text/html");
        return result.body.innerText;
    }
}
